"use client";
import Detailslist from "@/components/Detailslist/Detailslist";
import { blogs, blogFilter } from "@/utils/data";
import BlogCard from "../components/BlogsCarousel/BlogCard/BlogCard";
import BreadCrumbs from "@/components/BreadCrumbs/BreadCrumbs";

export default function FitnessBlogPage({ fitnessBlogs }) {


  const props = {
    heading: "Search accordingly your convenience",
    filterData: blogFilter,
  };

  return (
    <>
      <BreadCrumbs />
      <Detailslist props={props}>
        {fitnessBlogs.length > 0 &&
          fitnessBlogs.map((blog, i) => (
            <BlogCard key={i} blog={blog} isFitNess={true} />
          ))}
      </Detailslist>
    </>
  );
}
